import { useQuery } from 'react-query';

import { getFilteredCards } from 'api/endPoints/getFilteredCards';
import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';

export const cardsDataQueryKey = 'cardsData';
export const useQueryCardsData = (params) => {
    return useQuery<ISingleSmallCardResponse[], QueryError>(
        [cardsDataQueryKey, params],
        () => getFilteredCards(params),
        {
            enabled: Boolean(params) && params?.filter.filters.length > 0,
        },
    );
};
